import axios from "../axios/axios";
import { setPersonCategories, setProductCategories, setServiceCategories } from "../store/actions/categoryAction";
import { errorDispatcher } from "../helpers";
import { appSetLoading } from "../store/actions/appAction";
import { DateToString } from "../components/Reports/DateFilter";
import fileDownload from "js-file-download";


export const apiGetCategoryExcel = (token) => (dispatch, getState) => {
  let url = `categories/excel/export`;

  dispatch(appSetLoading());
  axios.get(url, {
      headers: { Authorization: `Bearer ${token}`},
      responseType: "blob"
    }
  ).then((response) => {
    dispatch(appSetLoading(false));
    const now = DateToString(Date.now()).replace("/", "_");
    const fileName = `categories_${now}`;
    fileDownload(response.data, `${fileName}.xlsx`);
  })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetProductCategories =
  (token, isProduct = true,callBack) =>
    (dispatch, getState) => {
      dispatch(appSetLoading(true));
      axios
        .get(`categories?type=${isProduct ? "products" : "services"}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
          if (isProduct) {
            dispatch(setProductCategories([response.data.categories]));
          } else {
            dispatch(setServiceCategories([response.data.categories]));
          }
          callBack([response.data.categories])
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch, false);
        });
    };

export const apiAddProductCategory =
  (category, token, isProduct = true) =>
    (dispatch, getState) => {
      axios
        .post("categories", category, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
          dispatch(apiGetProductCategories(token, isProduct));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch, false);
        });
    };

export const apiUpdateProductCategory =
  (category, token, isProduct = true) =>
    (dispatch, getState) => {
      axios
        .put(`categories/${category.id}`, category, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
          dispatch(apiGetProductCategories(token, isProduct));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch, false);
        });
    };

export const apiDeleteProductCategory =
  (categoryId, token, isProduct = true) =>
    (dispatch, getState) => {
      axios
        .delete(`categories/${categoryId}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
          dispatch(apiGetProductCategories(token, isProduct));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch, false);
        });
    };

export const apiGetPersonCategories = (token) => (dispatch, getState) => {
  axios
    .get("personTypes", {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      dispatch(setPersonCategories([response.data.personTypes]));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

export const apiAddPersonCategory = (category, token) => (dispatch, getState) => {
  axios
    .post("personTypes", category, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      dispatch(apiGetPersonCategories(token));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

export const apiUpdatePersonCategory = (category, token) => (dispatch, getState) => {
  axios
    .put(`personTypes/${category.id}`, category, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      dispatch(apiGetPersonCategories(token));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

export const apiDeletePersonCategory = (categoryId, token) => (dispatch, getState) => {
  axios
    .delete(`personTypes/${categoryId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      dispatch(apiGetPersonCategories(token));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
